// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__WkVoy","imageUploader":"EGiftCard_imageUploader__3x9Q9"};